export const alert_headers = [
    { key: 'USERNAME', value: 'PLAYER & ID', showArrowSort: true },
    { key: 'DETAIL', value: 'DETAIL', showArrowSort: true },
    { key: 'ALERT_LEVEL', value: 'SEVERITY', showArrowSort: true },
    { key: 'RULE_TYPE', value: 'RULE TYPE', showArrowSort: false },
    { key: 'RAISED_TIMESTAMP', value: 'RAISED TIMESTAMP', showArrowSort: true },
    { key: 'DISMISSED', value: 'STATUS', showArrowSort: false },
    { key: null, value: '' } /* This is the actions column. */
];
